import React, { useState } from 'react';
import { useTranslations } from 'next-intl';

import Copy from '@components/atoms/copy/copy';

import Popover from '../popover/popover';

import StyledInstructions from './instructions.style';

const Instructions = () => {
  const t = useTranslations();
  const [open, setOpen] = useState(false);
  return (
    <StyledInstructions>
      <Popover
        headline={t('wishes.instructions.headline')}
        placement="top-end"
        closeLabel={t('close')}
        offsetX={50}
        trigger={{
          isCircle: true,
          label: '?',
          ariaLabel: t('wishes.instructions.label')
        }}
        open={open}
        onOpen={setOpen}
      >
        <Copy
          dangerouslySetInnerHTML={{
            __html: t('wishes.instructions.copy')
          }}
        />
        <div className="instructions__hint">
          <Copy small noMargin>
            {t('wishes.instructions.hint')}
          </Copy>
          <video src="/static/video/wishesHint.mp4" autoPlay loop muted playsInline />
        </div>
      </Popover>
    </StyledInstructions>
  );
};

export default Instructions;
